module.exports = __webpack_public_path__ + "static/media/carousel_item_2-large.32a96525.png";